import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';

import {
  ClientDepartment,
  ClientFollowMappingFragment,
  ClientLocation,
  FollowConditions,
  Group,
  PublicUserProfileFragment,
} from 'api';

type TitleItem = ClientDepartment | ClientLocation | Group;
type Item = TitleItem | PublicUserProfileFragment;

interface IProps {
  title: string;
  listKey: keyof ClientFollowMappingFragment | keyof FollowConditions;
  mapping: ClientFollowMappingFragment;
}

const Names: FC<IProps> = ({ title, listKey, mapping }) => {
  const { follow_conditions } = mapping;
  const rootKey = mapping[listKey];
  const followConditionsKey = follow_conditions && follow_conditions[listKey];

  if (!rootKey && !followConditionsKey) {
    return null;
  }

  if ((rootKey && !rootKey.length) || (followConditionsKey && !followConditionsKey.length)) {
    return null;
  }

  function isProfile(
    item: TitleItem | PublicUserProfileFragment
  ): item is PublicUserProfileFragment {
    return (item as PublicUserProfileFragment).full_name !== undefined;
  }

  function getTitles() {
    const items = rootKey || followConditionsKey;

    return items
      .map((item: Item) => {
        return isProfile(item) ? item.full_name : item.title;
      })
      .join(', ');
  }

  return (
    <Grid item xs={4}>
      <Typography variant="subtitle2">{title}</Typography>
      <Typography color="textSecondary">{getTitles()}</Typography>
    </Grid>
  );
};

export default Names;
